export const getValueByPath = (
  obj: any,
  path: string,
  additionalKey: string
) => {
  // Add the additional key to the keys
  let fullPath
  if (additionalKey) {
    fullPath = `${path}.${additionalKey}`;
  } else {
    fullPath = `${path}`
  }

  const keys = fullPath.split('.');
  if (!obj) {
    return undefined;
  }
  let value = typeof obj === 'object' ? { ...obj } : JSON.parse(obj);
  for (const key of keys) {
    if (value && value.hasOwnProperty(key)) {
      value = value[key];
    } else {
      // Key does not exist in object or value is not an object
      return undefined;
    }
  }
  return value;
};

export const updateValueByPath = (
  obj: any,
  newValue: any,
  path: string,
  additionalKey?: string
) => {

  let fullPath = additionalKey ? `${path}.${additionalKey}` : path;
  const keys = fullPath.split('.');
  const key = keys.shift();

  if (!obj) {
    // If no object sent, then you create the object
    let newObj: any = {};
    let nestedObj: any = {};
    let lastKey = additionalKey?.trim() ? additionalKey: keys.pop();
    keys.reduce((acc: any, key: any) => {
      acc[key] = {}
      return acc[key];
    }, nestedObj)
    if (!lastKey) {
      return undefined;
    }
    nestedObj[lastKey] = newValue
    newObj["features"] = nestedObj;
    return newObj;
  }

  let value = typeof obj === 'object' ? { ...obj } : JSON.parse(obj);

  if (!key) {
    // If key is not provided or is empty, return the original value
    return value;
  }

  if (!value.hasOwnProperty(key)) {
    // If the key doesn't exist, create it and assign the new value
    if (keys.length === 0) {
      return { ...value, [key]: newValue };
    } else {
      // Create the key and initialize it as an empty object
      value[key] = {};
    }
  } else {
    // If the key exists, update its value
    if (keys.length === 0) {
      return { ...value, [key]: newValue };
    }
  }

  // Recursively update the nested value
  const updatedValue: any = updateValueByPath(
    value[key],
    newValue,
    keys.join('.')
  );

  // Create a new object with the updated value at the current key
  let result = { ...value, [key]: updatedValue };
  return result;
};

export const parseJSONValues = (obj: any) => {
  for (let key in obj) {
    if (typeof obj[key] === 'string') {
      try {
        obj[key] = JSON.parse(obj[key]);
      } catch (error) {
        // Ignore errors, the value is not JSON
      }
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      parseJSONValues(obj[key]);
    }
  }
  return obj;
};
